// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MessageRepo_GetChatsByPlatformAndDeviceKeysResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /message_repo/getChatsByPlatformAndDeviceKeys
 *
 * Returns a list of chats filtered by platform and device keys.
 * Data is proxied from external msgRepoApi service.
 *
 * @see MessageRepo_GetChatsByPlatformAndDeviceKeysRow for the per-chat shape.
 */
import type { MessageRepo_GetChatsByPlatformAndDeviceKeysRow } from './MessageRepo_GetChatsByPlatformAndDeviceKeysRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface MessageRepo_GetChatsByPlatformAndDeviceKeysResponseDados {
chats: MessageRepo_GetChatsByPlatformAndDeviceKeysRow[]
}

export type MessageRepo_GetChatsByPlatformAndDeviceKeysResponse = ApiResponse<MessageRepo_GetChatsByPlatformAndDeviceKeysResponseDados>;

registerResponseContract('MessageRepo_GetChatsByPlatformAndDeviceKeysResponse', {
  chats: {
    type: 'array',
    required: true,
    items: {
      id:                { type: 'string',  required: true },
      platform:          { type: 'string',  required: true },
      device_key:        { type: 'string',  required: true },
      name:              { type: 'string',  required: false },
      message_count:     { type: 'number',  required: false },
      last_message_date: { type: 'string',  required: false },
    },
  },
})
